import { useState } from "react";
import { Loader2 } from "lucide-react";

interface Props {
  defaultLabel: string;
  onCancel: () => void;
  onConfirm: (label: string) => Promise<void>;
}

export function SaveVersionDialog({ defaultLabel, onCancel, onConfirm }: Props) {
  const [label, setLabel] = useState(defaultLabel);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setErr(null);
    try {
      await onConfirm(label.trim() || defaultLabel);
    } catch (e) {
      setErr(String((e as Error).message ?? e));
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-stone-900/40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-md shadow-lg w-full max-w-sm p-4 space-y-3">
        <h2 className="font-serif-title text-base text-stone-800">Sauvegarder une nouvelle version</h2>
        <label className="block space-y-1">
          <span className="text-xs text-stone-600">Libellé de la version</span>
          <input
            className="w-full border border-stone-300 rounded px-2 py-1.5 text-sm"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            autoFocus
          />
        </label>
        {err && <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded p-2">{err}</div>}
        <div className="flex gap-2 pt-1">
          <button
            className="flex-1 border border-stone-300 rounded px-3 py-2 text-sm bg-white hover:bg-stone-50"
            onClick={onCancel}
            disabled={busy}
          >
            Annuler
          </button>
          <button
            className="flex-1 bg-stone-800 text-white rounded px-3 py-2 text-sm hover:bg-stone-700 disabled:opacity-50 flex items-center justify-center gap-2"
            onClick={submit}
            disabled={busy}
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
}
